import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import axios from 'axios';

import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import PropertyImageGallery from "../../components/propertyimagegallery";
import inquireButton from "../../assect/images/buttons/Inquire.png";

// const apiPath = 'https://localhost:7044/DimoraProperties';
// const apiPath = 'http://54.90.37.158/dimoraapi/dimoraproperties';
//const apiPath = 'https://dimoralivingwebapi.azurewebsites.net/dimoraproperties';
// const apiPath = 'https://dimoraliving.com/dimoraproperties';
// const apiPath = `${process.env.REACT_APP_API_URL}api/DimoraProperties`;
const apiPath = `${process.env.REACT_APP_API_URL}api/Properties`;

// Skeleton loader component for property details
const PropertyDetailSkeleton = () => {
  return (
    <div className="bg-white p-sm-4 p-3 rounded-3">
      <div className="row g-lg-5">
        {/* Image gallery skeleton */}
        <div className="col-md-6 col-12 mb-md-0 mb-4">
          <div className="skeleton-image-main mb-3"></div>
          <div className="d-flex justify-content-start gap-2 overflow-hidden">
            {[...Array(4)].map((_, index) => (
              <div key={index} className="skeleton-image-thumbnail"></div>
            ))}
          </div>
        </div>

        {/* Property details skeleton */}
        <div className="col-md-6 col-12">
          <div className="row g-2">
            <div className="col-sm-6">
              <ul className="property-stats">
                {[...Array(4)].map((_, index) => (
                  <li key={index} className="mb-2">
                    <div className="skeleton-text"></div>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-sm-6">
              <ul className="property-stats">
                {[...Array(4)].map((_, index) => (
                  <li key={index} className="mb-2">
                    <div className="skeleton-text"></div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="row g-2 mt-4">
            <div className="col-12">
              <div className="mt-2">
                <div className="skeleton-text skeleton-title mb-2"></div>
                <ul style={{ paddingLeft: '20px' }}>
                  {[...Array(5)].map((_, index) => (
                    <li key={index} className="mb-2">
                      <div className="skeleton-text skeleton-list-item"></div>
                    </li>
                  ))}
                </ul>
              </div>
              {[...Array(4)].map((_, index) => (
                <div key={index} className="skeleton-text skeleton-paragraph mb-2"></div>
              ))}
              <div className="skeleton-button mt-3"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default function PropertyDetail() {
    const [property, setProperty] = useState({});
    const [propertyId, setPropertyId] = useState(0);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [open, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(true);

    const mime = 'image/jpg';

    const handleImageClick = (index) => {
        setCurrentImageIndex(index);
        setIsOpen(true);
    };

    const { id } = useParams();

    const fetchData = async (apiGetPath) => {
        setLoading(true);
        try {
            // grab data from api and place into state
            const response = await axios.get(apiGetPath);
            const data = response.data;

            setProperty(prevState => ({
                ...prevState, ...data
            }));
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }

    useEffect(() => {
        setPropertyId(id);
    }, [id]);

    useEffect(() => {
        if (propertyId) {
            let apiGetPath = `${apiPath}/${propertyId}`;
            fetchData(apiGetPath);
        }
    }, [propertyId])

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('en-US');
    };

    return (
        <div style={{ backgroundColor: "#f0eadd" }}>
            <Navbar navClass="defaultscroll sticky" menuClass="navigation-menu nav-right" />
            <div className="container-lg py-120">
                {loading ? (
                    <PropertyDetailSkeleton />
                ) : (
                    <div className="bg-white p-sm-4 p-3 rounded-3">
                        <div className="row g-lg-5">
                            <div className="col-md-6 col-12 mb-md-0 mb-4">
                                <PropertyImageGallery property={property} />
                            </div>

                            <div className="col-md-6 col-12" >
                                <div className="row g-2">
                                    <div className="col-sm-6">
                                        <ul className="property-stats">
                                            <li><p style={{ fontSize: "15px", lineHeight: "1.5rem", fontWeight: "bold" }}>{`${property.address?.toUpperCase()}, UNIT ${property.unit}`}</p></li>
                                            <li><p style={{ fontSize: "15px", lineHeight: "1.5rem", fontWeight: "bold" }}>{`${property.city?.toUpperCase()}, ${property.state?.toUpperCase()}`}</p></li>
                                            <li><p style={{ fontSize: "15px", lineHeight: "1.5rem", fontWeight: "bold" }}><span style={{ fontWeight: "bold" }}>{`$${property.price}`}/MONTH</span></p></li>
                                            <li><p style={{ fontSize: "15px", lineHeight: "1.5rem", fontWeight: "bold" }}><span style={{ fontWeight: "bold" }}>{`Available: ${property.available === true ? 'Yes' : 'No'}`}</span></p></li>
                                        </ul>
                                    </div>

                                    <div className="col-sm-6">
                                        <ul className="property-stats">
                                            <li><p style={{ fontSize: "15px", lineHeight: "1.5rem", fontWeight: "bold" }}><span className="me-3" style={{ fontWeight: "bold" }}>{`BEDS: ${property.beds}  /  BATHS: ${property.baths}`}</span></p></li>
                                            <li><p style={{ fontSize: "15px", lineHeight: "1.5rem", fontWeight: "bold" }}><span className="me-3" style={{ fontWeight: "bold" }}>{`SQFT: ${property.sqft}`}</span></p></li>
                                            <li><p style={{ fontSize: "15px", lineHeight: "1.5rem", fontWeight: "bold" }}><span className="me-3" style={{ fontWeight: "bold" }}>{property.rentalTypeDisplay}</span></p></li>
                                            <li><p style={{ fontSize: "15px", lineHeight: "1.5rem", fontWeight: "bold" }}><span className="me-3" style={{ fontWeight: "bold" }}>{((property.availableDt!=="0001-01-01T00:00:00") && property?.available && (property?.price > 0)) ?`Date: ${formatDate(property.availableDt)}`:`Date: Not Available`}</span></p></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="row g-2 mt-14">
                                    <div className="col-12">
                                        {property.amenities && property.amenities.length > 0 && (
                                            <div className="mt-2">
                                                <p style={{ fontWeight: 'bold', fontSize: '16px' }} className="mb-2">Features:</p>
                                                <ul style={{ paddingLeft: '20px' }}>
                                                    {property.amenities.map((amenity, index) => (
                                                        <li key={index} style={{ fontSize: '15px', lineHeight: '1.5rem' }}>
                                                            {amenity.amenityTypeDisplay}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                         <p style={{ fontWeight: 'bold', fontSize: '16px' }} className="mb-2">Description:</p>
                                        <p style={{ fontSize: "16px" }}>{property.description}</p>
                                        <Link to={`/contactus/${id}`} target="_blank">
                                            <img src={inquireButton} alt="Inquire" width="100" height="41" className="scale_hover" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <Footer />
            
            {/* Custom CSS for skeleton loader */}
            <style jsx>{`
                /* Base skeleton animation */
                @keyframes skeleton-loading {
                    0% {
                        background-position: -200px 0;
                    }
                    100% {
                        background-position: calc(200px + 100%) 0;
                    }
                }
                
                /* Common skeleton styles */
                .skeleton-text,
                .skeleton-image-main,
                .skeleton-image-thumbnail,
                .skeleton-button {
                    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                    background-size: 200px 100%;
                    animation: skeleton-loading 1.5s infinite linear;
                    border-radius: 4px;
                }
                
                /* Text skeletons */
                .skeleton-text {
                    height: 18px;
                    width: 100%;
                }
                
                .skeleton-title {
                    height: 24px;
                    width: 40%;
                }
                
                .skeleton-list-item {
                    height: 16px;
                    width: 80%;
                }
                
                .skeleton-paragraph {
                    height: 16px;
                }
                
                /* Images skeletons */
                .skeleton-image-main {
                    height: 350px;
                    width: 100%;
                    margin-bottom: 10px;
                }
                
                .skeleton-image-thumbnail {
                    height: 80px;
                    width: 80px;
                    flex-shrink: 0;
                }
                
                /* Button skeleton */
                .skeleton-button {
                    height: 41px;
                    width: 100px;
                }
                
                /* Responsive adjustments */
                @media (max-width: 768px) {
                    .skeleton-image-main {
                        height: 250px;
                    }
                    
                    .skeleton-image-thumbnail {
                        height: 60px;
                        width: 60px;
                    }
                }
                
                @media (max-width: 576px) {
                    .skeleton-image-main {
                        height: 200px;
                    }
                    
                    .skeleton-image-thumbnail {
                        height: 50px;
                        width: 50px;
                    }
                }
            `}</style>
        </div>
    )
}